import state from './state';

export default {
  getRouting() {
    return state.routing;
  },

  getActiveVendors(state, getters, rootState, rootGetters) {
    const rate_table = rootState.rateTable.rateTable;
    const activeOperatorId = rootState.rateTable.activeRateId;
    const filterByfield = rate_table.rate_table_type === 'prefix' ? 'code' : 'mobile_network_uuid';

    if(!state.routing.routes) { return [] }
      let data = state.routing.routes.filter((route, index) => {
          if(route && rate_table.rates.length !== 0 && route[filterByfield] === rate_table.rates[activeOperatorId][filterByfield]) {
            state.activeRouteId = index;
            return true
          }
          return false
        });
        return data
  },

  getCurrentIndex() {
    return state.activeRouteId;
  }
}